export const localsPlacement = {
  house: 'placement.house',
  section: 'placement.section',
  floor: 'placement.floor',
};
